import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const FileUploadIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.66797 17.7384V22.0413C4.66797 22.6934 4.9138 23.3187 5.35139 23.7798C5.78897 24.241 6.38246 24.5 7.0013 24.5H21.0013C21.6201 24.5 22.2136 24.241 22.6512 23.7798C23.0888 23.3187 23.3346 22.6933 23.3346 22.0412V17.7384M14.0022 17.4329L14.0022 3.5M14.0022 3.5L8.66884 8.82371M14.0022 3.5L19.3355 8.82371"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

FileUploadIcon.displayName = 'FileUploadIcon';
